import React from 'react';
import { FilterApi } from './api';
import { createGlobalStyle } from 'styled-components';
import { loaderData } from './helpers/view/detailsHelper';

// translate value of radio buttons for query
export const interventionsReplace = (pYears: any) => {
  let valueToReturn = '';
  if (pYears.red === true) {
    valueToReturn += "'Intervention réseau',";
  }
  if (pYears.orange === true) {
    valueToReturn += "'Intervention installation',";
  }
  if (pYears.blue === true) {
    valueToReturn += "'Inspection réseau',";
  }
  if (valueToReturn === '') {
    valueToReturn =
      "'Intervention réseau','Intervention installation','Inspection réseau',";
  }
  const valueToReturnUpdated = valueToReturn.slice(0, -1);
  return valueToReturnUpdated;
};

export const dateFr = {
  // months list by order
  months: [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ],

  // Fonction qui permet d'afficher les jours en france dans le calendrier présent sur l'export et sur pr detail
  weekDays: [
    {
      name: 'Dimanche', // used for accessibility
      short: 'Di', // displayed at the top of days' rows
      isWeekend: true, // is it a formal weekend or not?
    },
    {
      name: 'Lundi',
      short: 'Lu',
    },
    {
      name: 'Mardi',
      short: 'Ma',
    },
    {
      name: 'Mercredi',
      short: 'Me',
    },
    {
      name: 'Jeudi',
      short: 'Je',
    },
    {
      name: 'Vendredi',
      short: 'Ve',
    },
    {
      name: 'Samedi',
      short: 'Sa',
      isWeekend: true,
    },
  ],

  // just play around with this number between 0 and 6
  weekStartingIndex: 0,

  // return a { year: number, month: number, day: number } object
  getToday(gregorainTodayObject) {
    return gregorainTodayObject;
  },

  // return a native JavaScript date here
  toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
  },

  // return a number for date's month length
  getMonthLength(date) {
    return new Date(date.year, date.month, 0).getDate();
  },

  // return a transformed digit to your locale
  transformDigit(digit) {
    return digit;
  },

  // texts in the date picker
  nextMonth: 'Next Month',
  previousMonth: 'Previous Month',
  openMonthSelector: 'Open Month Selector',
  openYearSelector: 'Open Year Selector',
  closeMonthSelector: 'Close Month Selector',
  closeYearSelector: 'Close Year Selector',
  defaultPlaceholder: 'Select...',

  // for input range value
  from: 'from',
  to: 'to',

  // used for input value when multi dates are selected
  digitSeparator: ',',

  // if your provide -2 for example, year will be 2 digited
  yearLetterSkip: 0,

  // is your language rtl or ltr?
  isRtl: false,
};

export const stringifyColorsBis = (state: any) => {  
  let colors: string[] = [];
  if (state.red && state.red === true) {
    colors.push("'ROUGE'");
  }
  if (state.orange && state.orange === true) {
    colors.push("'ORANGE'");
  }
  if (state.blue && state.blue === true) {
    colors.push("'BLEU'");
  }
  if (state.green && state.green === true) {
    colors.push("'VERT'");
  }
  if (state.grey && state.grey === true) {
    colors.push("'GRIS'");
  }
  if (state.black && state.black === true) {
    colors.push("'NOIR'");
  }
  if (state.purple && state.purple === true) {
    colors.push("'VIOLET'");
  }
  return colors;
};

//function to format string to id
export const stringtoId = (string: string) => {
  return string
    ?.toLowerCase()
    .replace(/\s+/g, '-')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
};

//get maximum  date from today and format it as modern date picker format
export const maximumDate = () => {
  const date: any = new Date();
  return {
    year: date?.getFullYear(),
    month: date?.getMonth() + 1,
    day: date?.getDate(),
  };
};

// refresh zoom domain of graphic after changing period of time selected
export const refreshZoomGraphic = (pWidget: any, pTresholdsTemps: any) => {
  let isDateUpdated = false;

  // get previous dates
  if (pWidget.tresholdsList && pWidget.tresholdsList.length > 0) {
    let prevDatesStart = pWidget.tresholdsList[0][0];
    let prevDatesEnd = pWidget.tresholdsList[0][1];
    let currentDatesStart = pTresholdsTemps.slice();
    let currentDatesEnd = pTresholdsTemps.slice();

    // compare new and previous dates selected
    if (
      new Date(currentDatesStart[0][0]['time']).getTime() !==
      new Date(prevDatesStart['time']).getTime()
    ) {
      isDateUpdated = true;
    }
    if (
      new Date(currentDatesEnd[0][1]['time']).getTime() !==
      new Date(prevDatesEnd['time']).getTime()
    ) {
      isDateUpdated = true;
    }
  }

  // apply update zoomDomain
  if (isDateUpdated) {
    let xmin = new Date(pTresholdsTemps[0][0]['time'].toString().valueOf());
    let xmax = new Date(pTresholdsTemps[0][1]['time'].toString().valueOf());
    let ymax = pTresholdsTemps[1][0]['value'];
    pWidget.zoomDomain = { x: [xmin, xmax], y: [0, ymax] };
  }
};

//function two show only two digits  after decimals without rounding;
export const showTwoDigits = (number: any) => {
  let rightValue: any;
  if (number !== 0) {
    rightValue = Number(number).toFixed(2);
  } else {
    rightValue = 0;
  }
  return rightValue;
};

export const prepareBCRequest = (pCodes: any[]) => {
  let objectids: string = '';
  pCodes.forEach((entry, index) => {
    objectids += entry['OBJECTID'] + (index === pCodes.length - 1 ? '' : ',');
  });
  return objectids;
};

export const prepareBcLabelToRequest = (pCodes: any[]) => {
  let ids = '';
  pCodes.forEach((enterprise) => {
    if (enterprise.avalPoint !== null) {
      if (ids === '') {
        ids = ids + "'" + enterprise.avalPoint + "'";
      } else {
        ids = ids + ",'" + enterprise.avalPoint + "'";
      }
    }
  });
  return ids;
};

// create request for all communes selected
export const getCommunes = async (code: any) => {
  const res = await FilterApi.getCommunesPR(code);
  return res.data;
};

// Return start date
export const lastMonthDate = () => {
  const currentDate = new Date();
  const lastMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - 1,
    currentDate.getDate(),
  );
  return lastMonth;
};

//format DatePicker Date function
export const formatDatePickerDate = (dateValue) => {
  if (!dateValue) {
    return undefined;
  }

  const day = String(dateValue.day).padStart(2, '0');
  const month = String(dateValue.month).padStart(2, '0');
  const year = dateValue.year;

  return `${day}/${month}/${year}`;
};

// Filter ecp popup indicators function
export const filterIndicator = (data, indicator) => {
  return Object.assign(
    {},
    data.filter((indic) => indic.type === indicator),
  )[0]?.value;
};

// Filter ecp show digits popup indicators function
export const showDigitsIndicValue = (indicator) => {
  return indicator !== null && indicator !== undefined
    ? showTwoDigits(indicator)
    : showTwoDigits(indicator) === 0
    ? 0
    : 'NR';
};
// Calculate Cumul Pluie function
export const calculateCumulPluie = (pluvioValue) => {
  let result: string = '';
  const calculRound =
    pluvioValue[0].rr !== null
      ? Math.round(100 * pluvioValue[0].rr) / 100
      : 'NR';
  result =
    calculRound === 0
      ? pluvioValue[0].rr
      : calculRound === 'NR'
      ? 'NR'
      : calculRound;
  return result;
};

// H2S Switch indicator Sublayers function
export const h2sSublayers = () => {
  // Get H2S indicator name
  const indicatorModule: string | null =
    window.sessionStorage.getItem('h2s_indicator');

  switch (indicatorModule) {
    case 'IndicatorBoonLister':
      return [112, 212];
    case 'IndicatorSejourCana':
      return [113, 213];
    case 'IndicatorSejourPR':
      return [114, 214];
    case 'IndicatorAutocurage':
      return [115, 215];
    default:
      return [116, 216];
  }
};

export const loaderDataComponent = (pLoading: boolean, pCustomCss?: any) => {
  const Styles = createGlobalStyle`.sds-reset-style{
      .loaderComponent {
          ${pCustomCss === undefined ? 
            `width: 34px;
            height: 34px;            
            border: 5px solid #FFF;
            border-bottom-color: #243977;
            border-radius: 50%;
            display: inline-block;
            box-sizing: border-box;
            animation: rotation 1s linear infinite;` 
            : pCustomCss}
        @keyframes rotation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
      } 
    }`;
  return (
    <>
      <Styles/>
      <div style={{ display: 'flex', justifyContent: 'center'}}>{pLoading === true && loaderData('loaderComponent')}</div>
    </>
  );
}
